import {
  EnvironmentProviders,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { ThamConfig } from './tham.const';
import { ThamService } from './tham.service';

export const provideTham = (config: ThamConfig): EnvironmentProviders => {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      ThamService.init(config);
    }),
  ]);
};
